var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcEdit = function SvgIcEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.97 3.82-2.78-2.78C19.49.34 18.58 0 17.67 0c-.91 0-1.82.35-2.52 1.04l-13 13L.06 21.8C-.25 22.94.64 24 1.74 24c.15 0 .3-.02.46-.06l7.75-2.08 13-13c1.4-1.39 1.4-3.65.02-5.04zM8.93 20.07 2.11 21.9l1.83-6.82 8.66-8.67 4.99 4.99-8.66 8.67zM21.56 7.45l-2.54 2.54L14.03 5l2.54-2.54c.3-.3.69-.46 1.11-.46s.81.16 1.11.46l2.78 2.78c.3.3.46.69.46 1.11 0 .42-.16.81-.46 1.11l-.01-.01z"
  })));
};
export default SvgIcEdit;